import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
const base64 = require('base-64')
Vue.use(Vuex)


let localhost = 'localhost'
var ipPattern = /http:\/\/((192)\.\d\d(\d|)\.\d\d(\d|)\.\d\d(\d|))\:/g
var match = ipPattern.exec(window.location.href)
if (match !== null) if (match.length > 0) if (match[1]) localhost = match[1]
const isLocalhost = window.location.href.includes('http://' + localhost + ':')

var getdomain = (url) => {
	return url.substring(url.indexOf('.') + 1)
}

var api_url = !isLocalhost ? 'https://sales.' + getdomain(window.location.hostname) : 'http://' + localhost + ':8888'
//var main_url = !isLocalhost ? 'https://checkout.' + getdomain(window.location.hostname) : 'http://' + localhost + ':8888'
let login_url = !isLocalhost ? 'https://login.' + getdomain(window.location.hostname) : 'http://' + localhost + ':8888/login'
//let domain = isLocalhost ? 'http://' + localhost + ':8888' : 'https://checkout.lunni.io/'
//process.env.VUE_APP_API_URL
var x = 0
var s = 0
export default new Vuex.Store({
	state: {
		api_url: api_url,
		carts: [],
		streets_unique: [],
		streets_unique_id: {},
		users: [],
		selected_user: 'Käyttäjä',
		route: 'kohde',
		loading: false,
		canceldialog: false,
		navwarndialog: false,
		locationdialog: false,
		removedialog: false,
		logoutdialog: false,
		drawer: false,
		usermenu: true,
		empty: false,
		qtyfocus: false,
		swap: null,
		autofocus: true,
		error: false,
		success: false,
		snack: {
			status: false,
			text: 'test',
			color: 'info'
		},
		locationsearch: '',
	},
	mutations: {
		error(state, payload) {
			state.snack = {
				status: true,
				text: payload,
				color: 'error'
			}
		},
		success(state, payload) {
			state.snack = {
				status: true,
				text: payload,
				color: 'success'
			}
		},
		info(state, payload) {
			state.snack = {
				status: true,
				text: payload,
				color: 'info'
			}
		},
		insertIntoCart(state, payload) {
			payload.product.qty = null
			payload.product.itemkey = 'cart' + payload.cart + 'x' + x
			x++
			state.carts[payload.cart].products.push(payload.product)
			state.autofocus = true
		},
		createCart(state, payload) {
			payload.code = ''
			payload.products = []
			state.carts.push(payload)
		},
		removeCart(state, payload) {
			if (payload.item.account_name !== 'Oma Varasto') {
				if (payload.item.multiple) {
					var x = false
					state.streets_unique[payload.item.parent].locations[payload.item.index].selected = false
					state.streets_unique[payload.item.parent].locations.forEach(element => {
						if (element.selected) x = true
					})
					state.streets_unique[payload.item.parent].selected = x
				}
				else {
					state.streets_unique[payload.item.index].selected = false
				}
				if (payload.index !== null) {
					state.carts.splice(payload.index, 1)
				}
			} else {
				state.carts = []
			}
			state.removedialog = false
		},
		init(state) {
			state.loading = true
			Vue.http
				.get(state.api_url + '/varastootto/act/selectuser_data')
				.then(res => {
					state.users = res.body
					state.loading = false
				}).catch((err) => {
					console.log('a')
					console.log(err)
					window.location = login_url + '/?ret=' + encodeURIComponent(window.location.href)
				})
			Vue.http
				.get(state.api_url + '/varastootto/act/kohteet_data')
				.then(res => {
					Object.keys(res.body.streets_unique).forEach(
						element => {
							if (res.body.streets_unique[element].length > 1) {
								var l = 0
								var search = ''
								var locations = res.body.streets_unique[element]
								locations.forEach(element2 => {
									element2.multiple = true
									element2.selected = false
									element2.index = l
									element2.parent = s
									search += element2.name + ' '
									l++
								})
								state.streets_unique.push({
									selected: false,
									multiple: true,
									index: s,
									account_id: res.body.streets_unique[element][0].account_id,
									account_name: res.body.streets_unique[element][0].account_name,
									street: res.body.streets_unique[element][0].street,
									locations: locations,
									search: search
								})
								s++
							}
							else {
								var location = res.body.streets_unique[element][0]
								location.selected = false
								location.index = s
								s++
								state.streets_unique.push(location)
							}
						}
					)
					// console.log(state.streets_unique)
					state.loading = false
				}).catch((err) => {
					console.log('b')
					console.log(err)
					window.location = login_url + '/?ret=' + encodeURIComponent(window.location.href)
				})
		}
	},
	actions: {
		cancel({ commit, state }) {
			var len = state.carts.length
			for (var i = 0; i < len; i++) {
				commit('removeCart', { item: state.carts[0] })
			}
			x = 0
			state.carts = []
			state.locationsearch = ''
			state.canceldialog = false
			router.push('kohde')
		},
		omacart({ commit }) {
			commit('createCart', {
				account_id: '',
				account_name: 'Oma Varasto',
				billing_account_id: '',
				billing_account_name: '',
				building: '',
				id: '-',
				name: '',
				street: '',
				selected: true,
			})
		},
		create_cart({ commit, state }, payload) {
			if (!state.carts[state.carts.indexOf(payload)]) commit('createCart', payload)
			else commit('info', 'Kohde on jo valittuna')
		},
		post({ state, commit, dispatch }) {
			state.loading = true
			var data = {
				selected_user_name: base64.encode(state.selected_user),
				kohde: [],
				seurantakoodi: [],
				kohdeproduct: [],
				tuote: [],
				quantity: []
			}
			state.carts.forEach(cart => {
				data.kohde.push(cart.id)
				data.seurantakoodi.push(cart.code)
				var kohdeproduct = []
				var quantity = []
				var tuote = []
				cart.products.forEach(product => {
					kohdeproduct.push(product.id || null)
					quantity.push(product.qty || null)
					if (!product.id)
						tuote.push(product.name)
					else tuote.push('-')
				})
				data.kohdeproduct.push(kohdeproduct)
				data.quantity.push(quantity)
				data.tuote.push(tuote)
			})
			Vue.http.post(state.api_url + '/varastootto/act/add_varastootto', data, {
				emulateJSON: true
			}).then(() => {
				dispatch('cancel')
				router.push('kohde')
				state.loading = false
				commit('success', 'Varasto-otto tallennettu')
			}).catch((err) => {
				state.loading = false
				commit('error', 'Yhteysvirhe! Yritä tallennusta uudestaan!')
			})
		},
		custom({ commit }, payload) {
			if (payload.name !== null && payload.name !== '') {
				commit('insertIntoCart', {
					cart: payload.index,
					product: {
						qty: null,
						name: payload.name,
						product_no: '-'
					}
				})
			}
		},
		navigate({ commit, state, dispatch }, payload) {
			var current = router.history.current.path.substring(1)
			if (current !== payload.to && payload.to !== payload.from) {
				if (payload.to) state.route = payload.to
				else dispatch('cancel')
				var x = false
				if (state.carts.length > 0) {
					state.carts.forEach(element => {
						if (element.products.length > 0) x = true
					})
				}
				if (x) {
					state.navwarndialog = true
				} else {
					state.navwarndialog = false
					dispatch('cancel')
					router.push(state.route)
				}
			}
		}
	}
})
